/**
 * Competency Service - Fetch competencies for filters and display
 */

import { apiRequest } from '../config/api.js'
import { handleApiError } from './errorHandler.js'

/**
 * Get all competencies (ordered by position)
 * @returns {Promise<Array<{id: number, position: number, name: string}>>}
 */
export async function getCompetencies() {
  try {
    const data = await apiRequest('/competencies', { method: 'GET' })
    return Array.isArray(data) ? data : []
  } catch (error) {
    handleApiError(error)
    throw error
  }
}
